import color from 'color';
export var isValidColor = function (c) {
    if (!c) {
        return false;
    }
    try {
        color(c);
    }
    catch (e) {
        return false;
    }
    return true;
};
//# sourceMappingURL=is-valid-color.js.map